import { OocSaleType } from "@/types/app/ooc/sale.type";
import { OocTabItem } from "@/modules/ooc/tab-item";
import OocSaleInterface from "@/interface/app/ooc/sale.interface";
import { ExtraCharge } from "@/modules/business/extra-charges";
import { PriceMoney } from "@/modules/location";
import { OrderOption } from "@/modules/ooc/order-option";

export class Sale implements OocSaleInterface {
  items: Array<any> = [];
  order_option: any;
  external_fees: Array<any> = [];
  discount: string = new PriceMoney({ amount: 0 }).getPricePackage();
  isDelivery: Boolean = false;
  isDiscount: Boolean = false;
  isOtherCharges: Boolean = false;
  delivery: number = 0;
  deliveryFee: string = new PriceMoney({ amount: 0 }).getPricePackage();
  constructor(data?: OocSaleType) {
    if (data) {
      this.items = data.items;
      this.order_option = new OrderOption(data.order_option);
      this.external_fees = data.external_fees?.map((fee) => new ExtraCharge(fee));
      this.setUpItems();
      this.calculateDiscount(data);
      this.checkIfDelivery();
      this.checkOtherCharges();
      this.getDeliveryFee();
    }
  }

  /**
   * set up the items in the sale
   * @private
   */
  private setUpItems() {
    this.items = this.items.map((item) => new OocTabItem(item));
  }

  /**
   * will loop over all the item and calculate discount
   * @param data
   * @private
   */
  private calculateDiscount(data) {
    const reducer = (previousValue, item) =>
      previousValue + item.discounts.reduce((acc, discount) => discount.amount + acc, 0);
    this.isDiscount = !!data.items.reduce(reducer, 0);
    this.discount = new PriceMoney({ amount: data.items.reduce(reducer, 0) }).getPricePackage();
  }

  /**
   * checks if the order type is delivery
   * @private
   */
  private checkIfDelivery() {
    this.isDelivery = this.order_option?.type === "DELIVERY";
  }

  /**
   * will get delivery fees
   * @private
   */
  private getDeliveryFee() {
    let deliveryFee = this.external_fees?.find((fee) => fee.name === "Delivery");
    this.delivery = deliveryFee?.amount || 0;
    this.deliveryFee = deliveryFee?.price || new PriceMoney({ amount: 0 }).getPricePackage();
  }

  /**
   * checks if there are extra charges ie service charges
   * @private
   */
  private checkOtherCharges() {
    this.isOtherCharges = !!this.order_option.charges.length;
  }
}
